module.exports = __webpack_public_path__ + "img/overview-mutualfunds.f73e1a73.svg";